import styled from "styled-components";
import Widget from "../../../../../components/baseWidget";
import { useWidgetContext } from "../../../../../helpers/hooks/useWidgetContext";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useMemo } from "react";
import sampleData from "./sampleData.json";
import { useMeasure } from "react-use";

const TableView = ({ data, width, height }) => {
  const rowData = useMemo(() => {
    return data?.rows;
  }, [data]);

  const columnData = useMemo(() => {
    return data?.columns.map((column) => ({
      id: column.accessor,
      header: column.header,
      cell: (props) => {
        return props.getValue();
      },
      meta: column,
    }));
  }, [data]);

  const table = useReactTable({
    data: rowData,
    columns: columnData,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <TableWrapper style={{ width, height }}>
      <table className="bordered" style={{ width: width - 15 }}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr>
              <td>███</td>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>███</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              <td></td>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>███</td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td>███</td>
            <td>███</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </TableWrapper>
  );
};

const TableWrapper = styled.div`
  background-color: ${({ theme }) => theme.widget.background};
  padding-left: 10px;
  overflow: scroll;
  table {
    border-spacing: 0;
    background-color: ${({ theme }) => theme.widget.background};
    border-collapse: separate;
    > thead {
      height: 55px;
      z-index: 100;
      position: sticky;
      > tr {
        > th {
          cursor: pointer;
          user-select: none;
          margin-left: 20px;
          font-size: 16px;
          color: ${({ theme }) => theme.text};
          font-weight: 700;
          position: relative;
          white-space: nowrap;
          padding: 0 0.5rem;
          border-bottom: 2px solid #e4e4e4;
          top: 0px;
          position: sticky;
          background-color: ${({ theme }) => theme.widget.background};
          &:first-child {
            > span {
              opacity: 0.4;
            }
          }
        }
      }
    }
    > tbody {
      > tr {
        > td {
          font-size: 15px;
          font-weight: 400;
          line-height: 21.48px;
          padding: 0 0.5rem;
          white-space: nowrap;
          border-bottom: 1px solid #e4e4e4;
          &:first-child {
            > span {
              opacity: 0.4;
            }
          }
        }
        height: 49px;
      }
    }
    > tfoot {
      bottom: 0px;
      height: 55px;
      position: sticky;
      > tr {
        > td {
          margin-left: 20px;
          font-size: 16px;
          color: ${({ theme }) => theme.text};
          font-weight: 700;
          position: relative;
          white-space: nowrap;
          padding: 0 0.5rem;
          border-top: 2px solid #e4e4e4;
          top: 0px;
          position: sticky;
          background-color: ${({ theme }) => theme.widget.background};
        }
      }
    }
  }
`;

const ListWidgetSample = () => {
  const widget = useWidgetContext();
  const title = widget?.widgetData?.title;
  const [ref, { width, height }] = useMeasure();

  return (
    <Widget ref={ref}>
      <Widget.Header>
        <Widget.Title>{title}</Widget.Title>
      </Widget.Header>
      <Widget.Content>
        <TableView data={sampleData} width={width} height={height - 25} />
      </Widget.Content>
    </Widget>
  );
};

export default ListWidgetSample;
